<template>
    <project-step-container
            prev-to="go_broad_to_go_narrow_11"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                {{getMessage(12, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"
                                :text="getMessage(12, 'gobroadtogonarrow-guide')"/>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(12, 'problem')}}</label>
                <textarea id="first-thing" type="text" v-model="form.problem" rows="3"></textarea>
            </b-col>
        </b-row>
        <upload-image :project-id="projectId" :step="step"/>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide"
    import UploadImage from "../../../core/Components/UploadImage"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"


    export default {
        name: "DeepCustomerEmpathy12",
        components: {ProjectStepContainer, UploadImage, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_SKETCH,
                urlNextProject:'rapid_experiments_with_customers_13',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.SKETCH_PROTOTYPE),
                projectId: Storage.getProjectId(this.$route.params.index),
                form: {
                    problem: ""
                },
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>